import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef,ElementRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { WhCsvBooking, Freight } from './whbooking.interface';
import { CsvService } from 'src/app/services/csv.service';
import { BookingsService } from '../bookings.service';
import { ToastrService } from 'ngx-toastr';
import { SelectionType, ColumnMode, RowHeightCache } from '@swimlane/ngx-datatable';
import { User } from '../../../model/users.model';
import { LocalStorage } from 'ngx-store';
import { isValid } from 'date-fns';


@Component({
  selector: 'app-importbookings',
  templateUrl: './importbookings.component.html',
  styleUrls: ['./importbookings.component.scss'],
  providers: [CsvService,BookingsService]
})
export class ImportbookingsComponent {
  @ViewChild('fileUploadSimple') fileInputVar: ElementRef;
  @LocalStorage() user: User;


  constructor(private _csvService: CsvService, private _bookingsService: BookingsService,  private toastr: ToastrService, private _fb: FormBuilder) {}
  selected: any = [];
  loadingIndicator = false;
  enableOrderTypeSelector: boolean = false;
  submitted = false;
  warehouses = [];
  warehouseCompany = '';
  whId: number = 0;
  whAddress: string = '';
  public whFrm: FormGroup; 
  editing = {};
  whSelecting = {};
  rows = [];
  SelectionType = SelectionType;
  ColumnMode = ColumnMode;

  @ViewChild('consignmentsTable', {static: false}) table: any;



  sType = this.SelectionType.checkbox;

  public ORDER_TYPE = {
    SALES: 'sales',
    PURCHASE: 'purchase',
    CUSTOM: 'custom'
  }

  public ORDER_TYPE_LABEL = {
    SALES: 'Sales Order',
    PURCHASE: 'Purchase Order',
    CUSTOM: 'Custom'
  }

  public rawData:Array<any> = [];
  public importedData: WhCsvBooking[] = [];

  public is_atl :boolean = false;
  public is_premise_type :boolean = false;
  public is_tail_lift : boolean = false;
  public is_dg : boolean = false;
  
  public premise_types : any;
  public dg_types : any;
  public dg_classes : any;

  resetFileUpload() {
    this.fileInputVar.nativeElement.value = '';
  }   

  public async importDataFromCSV(event: any) {
    this.importedData = [];
    if (event.target.value) {
      let fileContent = await this.getTextFromFile(event);
      //fileContent = fileContent.replace(/"(?:""|[^"])+"/g, function(x) { return x.replace(/[^\S\r\n]*[\n\r]\s*/g, '');});
      this.rawData = this._csvService.importDataFromCSV(fileContent);

      this.rawData.forEach((value,index,object) => {
        /// process column names
        for (var property in value) {
          var temp = value[property];
          property = property.toUpperCase();
          if (property.includes('CONSIGNMENT')) property = 'CONSIGNMENT';
          if (property.includes('INSTRUCTION')) property = 'INSTRUCTIONS';
          if (property.includes('PRICE') ||property.includes('AMOUNT') ) property = 'PRICE';
          if (property.includes('FUEL')) property = 'FUEL';
          if (property.includes('SERVICE')) property = 'SERVICE';

          if (property.includes('COMPANY') && (property.includes('1') || property.includes('PICKUP') || property.includes('PU')) ) property = 'COMPANY1';
          else if (property.includes('COMPANY') && (property.includes('2') || property.includes('DEL')) ) property = 'COMPANY2';
          else if (property.includes('COMPANY')) property = 'COMPANY';

          if (property.includes('ADDRESS') && (property.includes('1') || property.includes('PICKUP') || property.includes('PU') ) ) property = 'ADDRESS1';
          else if (property.includes('ADDRESS') && (property.includes('2') || property.includes('DEL')) ) property = 'ADDRESS2';
          else if (property.includes('ADDRESS')) property = 'ADDRESS';

          if (property.includes('SUBURB') && (property.includes('1') || property.includes('PICKUP') || property.includes('PU') ) ) property = 'SUBURB1';
          else if (property.includes('SUBURB') && (property.includes('2') || property.includes('DEL')) ) property = 'SUBURB2';
          else if (property.includes('SUBURB')) property = 'SUBURB';

          if (property.includes('POST') && (property.includes('1') || property.includes('PICKUP') || property.includes('PU')  ) ) property = 'POSTCODE1';
          else if (property.includes('POST') && (property.includes('2') || property.includes('DEL')) ) property = 'POSTCODE2';
          else if (property.includes('POST')) property = 'POSTCODE';

          if (property.includes('STATE') && (property.includes('1') || property.includes('PICKUP') || property.includes('PU')  ) ) property = 'STATE1';
          else if (property.includes('STATE') && (property.includes('2') || property.includes('DEL')) ) property = 'STATE2';
          else if (property.includes('STATE')) property = 'STATE';

          if (property.includes('DATE') && (property.includes('1') || property.includes('PICKUP') || property.includes('PU')) ) property = 'DATE1';
          else if (property.includes('DATE') && (property.includes('2') || property.includes('DEL')) ) property = 'DATE2';
          else if (property.includes('DATE')) property = 'DATE';

          if (property.includes('TIME') && (property.includes('1') || property.includes('PICKUP') || property.includes('PU')) ) property = 'TIME1';
          else if (property.includes('TIME') && (property.includes('2') || property.includes('DEL')) ) property = 'TIME2';
          else if (property.includes('TIME')) property = 'TIME';

          if (property.includes('ATL') && (property.includes('1') || property.includes('PICKUP') || property.includes('PU')) ) property = 'ATL1';
          else if (property.includes('ATL') && (property.includes('2') || property.includes('DEL')) ) property = 'ATL2';
          else if (property.includes('ATL')) property = 'ATL';

          if (property.includes('PREMISE_TYPE') && (property.includes('1') || property.includes('PICKUP') || property.includes('PU')) ) property = 'PREMISE_TYPE1';
          else if (property.includes('PREMISE_TYPE') && (property.includes('2') || property.includes('DEL')) ) property = 'PREMISE_TYPE2';
          else if (property.includes('PREMISE_TYPE')) property = 'PREMISE_TYPE';

          if (property.includes('TAIL_LIFT') && (property.includes('1') || property.includes('PICKUP') || property.includes('PU')) ) property = 'TAIL_LIFT1';
          else if (property.includes('TAIL_LIFT') && (property.includes('2') || property.includes('DEL')) ) property = 'TAIL_LIFT2';
          else if (property.includes('TAIL_LIFT')) property = 'TAIL_LIFT';

          if (property.includes('DGTYPE')) property = 'DGTYPE';
          if (property.includes('DGCLASS')) property = 'DGCLASS';

          //check presence of new fields
          if (property.includes('ATL1') || property.includes('ATL')){this.is_atl = true;};
          if (property.includes('[PREMISE_TYPE1]') || property.includes('PREMISE_TYPE')){this.is_premise_type = true;};
          if (property.includes('[TAIL_LIFT1]') || property.includes('TAIL_LIFT')){this.is_tail_lift = true;};
          if (property.includes('DGTYPE')){this.is_dg = true;};
          
          value[property] = temp;
          value.error = null;
          value.created_by = this.user.id;
        }

        console.log('CCC CONSIGNMENT',value.ADDRESS1);
      
        if (value.CONSIGNMENT == null) {
          object.splice(index, 1);
        } else if (value.ADDRESS1 || value.ADDRESS2){
          console.log('pickup and delivery data on CSV');
          // TODO: Disable selection for order types
          this.enableOrderTypeSelector = false;
          this.setOrderType(this.ORDER_TYPE.CUSTOM);

          if (value.ADDRESS1 && value.SUBURB1) 
            value.pickup = value.ADDRESS1 + ", " + value.SUBURB1 + " " + value.STATE1+ " " + value.POSTCODE1;
          else value.pickup = '';
          value.pickupCompany = value.COMPANY1;
          value.pickupLocationId = null;

          if (value.DATE1 && this.isValidDate(value.DATE1)) {
            value.pickupDate = value.DATE1; 
            if (!value.DATE2 || this.isValidDate(value.DATE2) == false)
              value.deliveryDate = value.DATE1;
            else value.deliveryDate  = value.DATE2;
          }
          else {
            if (value.DATE2 && this.isValidDate(value.DATE2)) {
              value.pickupDate = value.DATE2;
              value.deliveryDate = value.DATE2;
            }
            else {
              if (value.DATE) {
                value.pickupDate = value.DATE; 
                value.deliveryDate = value.DATE;
              }
              else {
                value.pickupDate = this.getCurrentDate();
                value.deliveryDate = this.getCurrentDate();
  
              }

            }
          } 



          if (value.TIME1 && this.isValidTimeString(value.TIME1)) 
              value.pickupTime = value.TIME1;
          else value.pickupTime = this.getDefaultTime(15);

          if (value.ADDRESS2 && value.SUBURB2) 
            value.delivery = value.ADDRESS2 + ", " + value.SUBURB2 + " " + value.STATE2 + " " + value.POSTCODE2;
          else value.delivery = '';
            value.deliveryCompany = value.COMPANY2;
      
    /*    if (value.DATE2 && this.isValidDate(value.DATE2)) {
            value.deliveryDate = value.DATE2; 
          } else value.deliveryDate = this.getCurrentDate();
    */      
          if (value.TIME2  && this.isValidTimeString(value.TIME2))
            value.deliveryTime = value.TIME2;
          else value.deliveryTime = this.getDefaultTime(30);

          if (!value.TIME1 && !value.TIME2) {
            if (value.TIME && this.isValidTimeString(value.TIME)) {
              value.pickupTime = value.TIME;
              value.deliveryTime = value.TIME;
            }
            else {
              value.pickupTime = this.getDefaultTime(15);
              value.deliveryTime = this.getDefaultTime(30);
  
            }
          }



          value.deliveryLocationId = null;
          console.log("pickup date", value.pickupDate);
          console.log("delivery date", value.deliveryDate);
          value.pickupDateTime = this.convertToStandardDate(value.pickupDate) + " " + value.pickupTime;
          value.deliveryDateTime = this.convertToStandardDate(value.deliveryDate) + " " + value.deliveryTime;

          var p = new Date (value.pickupDateTime);
          var d = new Date (value.deliveryDateTime);

          if (p >= d) {
            console.log('invalid date');
            value.pickupDateTime = value.deliveryDateTime;
            value.pickupDate = value.deliveryDate;
            d.setMinutes ( d.getMinutes() + 15 );
            value.deliveryTime = d.getHours() + ":" + d.getMinutes();
            value.deliveryDateTime = this.convertToStandardDate(value.deliveryDate) + " " + value.deliveryTime;
          } 
        }
        else {
          this.enableOrderTypeSelector = true;
          console.log('company',value.COMPANY);

          // process pickup date and time
          if (value.DATE) {
            value.pickupDate = value.DATE; 
            value.deliveryDate = value.DATE;
          }
          else {
            value.pickupDate = this.getCurrentDate();
            value.deliveryDate = this.getCurrentDate();
          }

          if (value.TIME) {
            value.pickupTime = value.TIME;
            value.deliveryTime = value.TIME;
          }
          else {
            value.pickupTime = this.getDefaultTime(15);
            value.deliveryTime = this.getDefaultTime(15);
          }

          
          console.log('pickup date',value.pickupDate);
          console.log('pickup time',value.pickupTime);
          console.log('error coming');
          value.pickupDateTime = this.convertToStandardDate(value.pickupDate) + " " + value.pickupTime;
          value.deliveryDateTime = this.convertToStandardDate(value.deliveryDate) + " " + value.deliveryTime;


          /// process warehouse entries
          if (this.getOrderType() == this.ORDER_TYPE.SALES) {

            value.pickupLocationId = this.whId;
            value.pickup =this.whAddress;
            value.pickupCompany = this.warehouseCompany;
            value.delivery = value.ADDRESS + ", " + value.SUBURB + " " + value.STATE + " " + value.POSTCODE;
            value.deliveryCompany = value.COMPANY;
            value.deliveryLocationId = null;
          } else if (this.getOrderType() == this.ORDER_TYPE.PURCHASE) {
              value.deliveryLocationId = this.whId;
              value.delivery =this.whAddress;
              value.pickup = value.ADDRESS + ", " + value.SUBURB + " " + value.STATE + " " + value.POSTCODE;
              value.pickupCompany = value.COMPANY;
              value.pickupLocationId = null;
            } else {
              value.pickup = value.ADDRESS + ", " + value.SUBURB + " " + value.STATE + " " + value.POSTCODE;
              value.pickupLocationId = null;
              value.pickupCompany = value.COMPANY
              value.deliveryLocationId = null;
              value.delivery = '';
              value.deliveryCompany = '';
            }
        }
        
        
      }); /// END FOREACH importedData
      
      var tempData = this.rawData.filter((item, index) => {
        var arrayIndex = this.rawData.map(function(e) { return e.CONSIGNMENT; }).indexOf(item.CONSIGNMENT);
        return ( (arrayIndex === index) && (item.CONSIGNMENT != null) ) ;
      });

      
      tempData.forEach((value,index,object) => {
        var freights: Freight[];
        /* freights  = this.rawData.filter((item, index) => {
          return value.CONSIGNMENT === item.CONSIGNMENT;
        
        }); */
        this.importedData[index] = tempData[index];
        this.importedData[index]['freights'] = [];

        
        this.rawData.forEach((rawValue,rawIndex,rawObj) => {
          
          if (rawValue.CONSIGNMENT == value.CONSIGNMENT){
            var freightArray: any[];
            var row: any = {};
            row.ITEMS = rawValue.ITEMS;
            row.WEIGHT = rawValue.WEIGHT;
            row.LENGTH = rawValue.LENGTH;
            row.WIDTH = rawValue.WIDTH;
            row.HEIGHT = rawValue.HEIGHT;
            row.PACKAGING = rawValue.DESCRIPTION;
            row.INSTRUCTIONS = rawValue.INSTRUCTIONS;
            //freightArray.push(row);
            this.importedData[index]['freights'].push(row);
          } 
        });
        
     });

      
    }  // END IF EVENT TARGET

    console.log('MODIFIED');
    console.log(this.importedData);
  }

  private async getTextFromFile(event:any){
      const file: File = event.target.files[0];
      let fileContent = await file.text();

      return fileContent;
  }
  


  ngOnInit(): void {
    this.initWhBookingFrm();
    this.getWhCsvData();
  }

  processForm(data: WhCsvBooking[]) {
    console.log('processing form');
    data.forEach((value) => {
      var packagings = [];
      value.freights.forEach((f,i) => {
        var box = {};
        box['items'] = f['ITEMS'];
        box['weight'] = f['WEIGHT'];
        box['length'] = f['LENGTH'];
        box['width'] = f['WIDTH'];
        box['height'] = f['HEIGHT'];
        packagings[i] = box;
      }); 
      value.freight_json = JSON.stringify(packagings);
    }); 

    this.save(data);

  }
  

  save(model: WhCsvBooking[]) {
    console.log('final result');
    console.log(model);
    
    this.loadingIndicator = true;
    this._bookingsService.saveWhCsvBooking(model).toPromise().then(async res => {
      var error = res['error'];
      setTimeout(() => { 
  
        if (error==false) {
          this.submitted = true;
          this.selected = [];

          this.loadingIndicator = false;
          this.importedData = res['results'];
          this.toastr.success("Results are listed below.", "Bookings were processed!", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        }
        else {
          console.log("Failed Booking ", res);
          this.loadingIndicator = false;
          this.toastr.error("Please try again later.", "A problem was encountered while processing your booking.", {
            timeOut: 5000,
            positionClass: 'toast-top-full-width',
            progressBar: true
          });
        }
        
      }, 1500);
    },error => {  

      console.log('ERROR Fetching data...');
      console.log(error);
      setTimeout(() => { 
        this.loadingIndicator = false;
        this.toastr.error("Please try again later.", "A problem was encountered while processing your booking.", {
          timeOut: 5000,
          positionClass: 'toast-top-full-width',
          progressBar: true
        });
        
      }, 1500);

}
    );  

  }


  getWhCsvData() {
    const whIdCtrl: FormControl = (<any>this.whFrm).controls["whSiteId"];

    this.loadingIndicator = true;
    this._bookingsService.getImportCsvData().subscribe( data => {
      this.warehouseCompany = data['warehouse_company'];
      this.warehouses = data['warehouses'];
      this.premise_types = data['premise_types'];
      this.dg_types = data['dg_types'];
      this.dg_classes = data['dg_classes'];

      if (this.warehouses.length > 0) {
        this.whAddress = this.warehouses[0]['text'];
        this.whId = this.warehouses[0]['location_id'];
        whIdCtrl.setValue(this.whId);
      }
      this.loadingIndicator = false;
  },
      error => {  
      console.log('ERROR Fetching data...');
      console.log(error);
      this.loadingIndicator = false;


  }
  
  );
}

initWhBookingFrm() {
  this.whFrm = this._fb.group({
    orderType: ['sales'],
    whSiteId: []
  })
}


setOrderType(type: string) {
  console.log(this.warehouses);
  // update job type value
  const ctrl: FormControl = (<any>this.whFrm).controls["orderType"];
  ctrl.setValue(type);

  if (this.importedData.length> 0 && this.warehouses.length > 0) {
    if (type=="sales") {
      console.log('sales');
      this.importedData.forEach((value) => {
        if (this.whId) {
          value.pickupLocationId = this.whId;
          value.pickup = this.whAddress;
          value.pickupCompany = this.warehouseCompany;
        }else {
          console.log('no warehouse selected');
          value.pickupLocationId =null;
          value.pickup = '';
        }
        
        value.delivery = value.ADDRESS + ", " + value.SUBURB + " " + value.STATE + " " + value.POSTCODE;
        value.deliveryCompany = value.COMPANY;
        value.deliveryLocationId = null;
      }); 
  
    }
    else if (type=="purchase") {
      console.log('purchase');
      this.importedData.forEach( (value) => {
        if (this.whId) {
          value.deliveryLocationId = this.whId;
          value.delivery = this.whAddress;
          value.deliveryCompany = this.warehouseCompany;
        } else {
          console.log('no warehouse selected');
          value.deliveryLocationId =null;
          value.delivery = '';
        }
        value.pickup = value.ADDRESS + ", " + value.SUBURB + " " + value.STATE + " " + value.POSTCODE;
        value.pickupCompany = value.COMPANY;
        value.pickupLocationId = null;
      }); 
    }
    else { // custom
      console.log('custom selected');
    }
  }
  this.importedData = [...this.importedData];

console.log(this.importedData);
  

}  // END SET ORDER TYPE

selectWarehouse($event) {
  this.whId = $event.target.value;
  this.whAddress = $event.target.options[$event.target.options.selectedIndex].text;
}

getOrderType() { 

  const typeCtrl = (<any>this.whFrm).controls.orderType;

  return typeCtrl.value; 
}

updateValue(event, cell, rowIndex) {
  console.log('inline editing rowIndex', rowIndex);
  console.log(cell);
  this.editing[rowIndex + '-' + cell] = false;
  this.importedData[rowIndex][cell] = event.target.value;
  if (cell == 'pickup') this.importedData[rowIndex]['pickupLocationId'] = null;  
  if (cell == 'delivery')  this.importedData[rowIndex]['deliveryLocationId'] = null;  
  
  if (cell == 'pickupDate') {
    if (event.target.value && this.isValidDate(event.target.value))
      this.importedData[rowIndex]['pickupDate'] = event.target.value;
    else this.importedData[rowIndex]['pickupDate'] = this.getCurrentDate();
    this.importedData[rowIndex]['pickupDateTime'] = this.convertToStandardDate(this.importedData[rowIndex]['pickupDate']) + " " + this.importedData[rowIndex]['pickupTime'];
  }
  if (cell == 'deliveryDate') {
    if (event.target.value && this.isValidDate(event.target.value))
      this.importedData[rowIndex]['deliveryDate'] = event.target.value;
    else this.importedData[rowIndex]['deliveryDate'] = this.getCurrentDate();
    this.importedData[rowIndex]['deliveryDateTime'] = this.convertToStandardDate(this.importedData[rowIndex]['deliveryDate']) + " " + this.importedData[rowIndex]['deliveryTime'];
  }


  if (cell == 'pickupTime') {
    if (event.target.value && this.isValidTimeString(event.target.value))
      this.importedData[rowIndex]['pickupTime'] = event.target.value;
    else this.importedData[rowIndex]['pickupTime'] = this.getDefaultTime();
    this.importedData[rowIndex]['pickupDateTime'] = this.convertToStandardDate(this.importedData[rowIndex]['pickupDate']) + " " + this.importedData[rowIndex]['pickupTime'];
  }
  if (cell == 'deliveryTime') {
    if (event.target.value && this.isValidTimeString(event.target.value))
      this.importedData[rowIndex]['deliveryTime'] = event.target.value;
    else this.importedData[rowIndex]['deliveryTime'] = this.getDefaultTime(30);
    this.importedData[rowIndex]['deliveryDateTime'] = this.convertToStandardDate(this.importedData[rowIndex]['deliveryDate']) + " " + this.importedData[rowIndex]['deliveryTime'];
  }

  if (cell == 'ATL1') {
    if (event.target.value){
      this.importedData[rowIndex]['ATL1'] = event.target.value;
    }
  };

  if (cell == 'PREMISE_TYPE1') {
    if (event.target.value){
      this.importedData[rowIndex]['PREMISE_TYPE1'] = event.target.value;
    }
  };

  if (cell == 'TAIL_LIFT1') {
    if (event.target.value){
      this.importedData[rowIndex]['TAIL_LIFT1'] = event.target.value;
    }
  };


  if (cell == 'ATL2') {
    if (event.target.value){
      this.importedData[rowIndex]['ATL2'] = event.target.value;
    }
  };

  if (cell == 'PREMISE_TYPE2') {
    if (event.target.value){
      this.importedData[rowIndex]['PREMISE_TYPE2'] = event.target.value;
    }
  };

  if (cell == 'TAIL_LIFT1') {
    if (event.target.value){
      this.importedData[rowIndex]['TAIL_LIFT2'] = event.target.value;
    }
  };

  if (cell == 'DGTYPE') {
    if (event.target.value){
      this.importedData[rowIndex]['DGTYPE'] = event.target.value;
    }
  };

  if (cell == 'DGCLASS') {
    if (event.target.value){
      this.importedData[rowIndex]['DGCLASS'] = event.target.value;
    }
  };
  
  this.importedData = [...this.importedData];
  console.log('UPDATED!', this.importedData);
  this.adjustOrderType();
}

setOrderTypeValue(type) {
  const ctrl: FormControl = (<any>this.whFrm).controls["orderType"];
  ctrl.setValue(type);
}

insertWarehouse(cell, rowIndex) {

  this.setOrderTypeValue(this.ORDER_TYPE.CUSTOM);
  console.log('adding warehouse address', rowIndex);
  this.importedData[rowIndex][cell] = this.whAddress;
  
  if (cell == 'pickup') this.importedData[rowIndex]['pickupLocationId'] = this.whId;
  if (cell == 'delivery') this.importedData[rowIndex]['deliveryLocationId'] = this.whId;

  this.importedData = [...this.importedData];
  this.adjustOrderType();
}

adjustOrderType() {
  var pickupWhCount = 0;
  var deliveryWhCount = 0;
  this.importedData.forEach(function (value) {
    if (value.pickupLocationId) pickupWhCount++;
    if (value.deliveryLocationId) deliveryWhCount++;
  }); 
  if (pickupWhCount && !deliveryWhCount) this.setOrderTypeValue(this.ORDER_TYPE.SALES)
  else if (deliveryWhCount && !pickupWhCount) this.setOrderTypeValue(this.ORDER_TYPE.PURCHASE)
  else this.setOrderTypeValue(this.ORDER_TYPE.CUSTOM)

}

isEmpty(str) {
  str = str.toString();
  if (str != null) {
    if (str.trim() == '') return true;
      else return false;
  }
  else return true;
}


  getCellClass({ row }): any {
    return {
      'is-completed': row.error == false,
      'is-overdue': row.error == true,
      // 'is-withdrawn': row.is_assigned == '0' && row.is_enabled == '0',
      // 'is-subcontracted': row.is_assigned == '0' && row.is_enabled == '0',
      // 'is-draft': row.is_assigned == '0' && row.is_enabled == '0',

    };
  }


  displayCheck(row): any {
    return (this.submitted == false || row.error!=false);
  }



  show() {
    console.log(this.selected);
  }


  toggleExpandRow(row) {
    console.log('Toggled Expand Row!', row);
    this.table.rowDetail.toggleExpandRow(row)
  }

  onDetailToggle(event) {
    console.log('toggle detail');
  }


  isArray(a){var g=a.constructor.toString();
    if(g.match(/function Array()/)){return true;}else{return false;}
 }
 objtostring(o){var a,k,f,freg=[],txt; if(typeof o!='object'){return false;}
    if(this.isArray(o)){a={'t1':'[','t2':']','isarray':true}
    }else         {a={'t1':'{','t2':'}','isarray':false}}; txt=a.t1;
    for(k in o){
            if(!a.isarray)txt+="'"+k+"':";
            if(typeof o[k]=='string'){txt+="'"+o[k]+"',";
            }else if(typeof o[k]=='number'||typeof o[k]=='boolean'){txt+=o[k]+",";
            }else if(typeof o[k]=='function'){f=o[k].toString();freg=f.match(/^function\s+(\w+)\s*\(/);
                if(freg){txt+=freg[1]+",";}else{txt+=f+",";};
            }else if(typeof o[k]=='object'){txt+=this.objtostring(o[k])+",";
            }
    }return txt.substr(0,txt.length-1)+a.t2;
 }


getCurrentDate() {
  // Date object
const date = new Date();

let currentDay= String(date.getDate()).padStart(2, '0');

let currentMonth = String(date.getMonth()+1).padStart(2,"0");

let currentYear = date.getFullYear();

// we will display the date as DD-MM-YYYY 

let currentDate = `${currentDay}-${currentMonth}-${currentYear}`;
return currentDate;
}

getDefaultTime(addMinute = 0) {
  var d1 = new Date (),
    d2 = new Date ( d1 );

  d2.setMinutes ( d1.getMinutes() + addMinute );
  var minutes = d2.getMinutes();
  var minuteStr;
  console.log("minutes",minutes);
  if (minutes < 10) minuteStr = "0" + minutes.toString(); else minuteStr = minutes.toString();

  return d2.getHours() + ":" + minuteStr;
}

fixDate(date) {
  let day = date.getDate(); // 1
  let month = date.getMonth() + 1; // 0
  let year = date.getFullYear(); // 2020
}

convertToStandardDate (dateStr) {
 /*  console.log('original date', date);
  
  console.log('standard date',standardDate);
  var d = new Date(standardDate);
  console.log('converted ISO date',d.toISOString().slice(0,10) );
  return d.toISOString().slice(0,10); */
var standardDate =  dateStr.split("-").reverse().join("-");

  console.log('original date', standardDate);
  let date = new Date(standardDate);
let day = date.getDate(); // 1
let newDay = day.toString().padStart(2, '0'); // '01'
let month = date.getMonth() + 1; // 1
let newMonth = month.toString().padStart(2, '0'); // '01'
let year = date.getFullYear(); // 2020
let newDate = year + '-' + newMonth + '-' + newDay;
console.log('new date',newDate); 
return newDate;
}




isValidDate(strDate) {
  console.log('validating',strDate, strDate.length);
  if (strDate.length < 8 || strDate.length > 10) return false;
  var dateParts = strDate.split("-");
  var date = new Date(dateParts[2], (dateParts[1] - 1), dateParts[0]);
  if (date.getDate() == dateParts[0] && date.getMonth() == (dateParts[1] - 1) && date.getFullYear() == dateParts[2]) 
      return true;
  else{ console.log('date str is invalid');
    return false;
  }
}

 isValidTimeString(timeStr) {
  var isValid = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(timeStr);
  console.log('valid time string?',isValid);

  return isValid;
}




}